export default __webpack_public_path__ + "static/media/3.7d709c13.jpg";